import { FunctionComponent } from 'react';
import { CEMainModal } from 'widgets/auth/changeEmail/_MainModal';

export const ChangeEmail: FunctionComponent = () => {
	return <CEMainModal />;
};
